import { useEffect, useRef } from "react";
import { useMap } from "@vis.gl/react-google-maps";

interface SearchRadiusCourt {
  id: string;
  lat: number;
  lng: number;
  radius: number;
}

interface SearchRadiusOverlayProps {
  courts: SearchRadiusCourt[];
}

export function SearchRadiusOverlay({ courts }: SearchRadiusOverlayProps) {
  const map = useMap();
  const circlesRef = useRef(new Map<string, google.maps.Circle>());

  useEffect(() => {
    if (!map) return;

    const current = circlesRef.current;
    const activeIds = new Set(courts.map((c) => c.id));

    for (const [id, circle] of current) {
      if (!activeIds.has(id)) {
        circle.setMap(null);
        current.delete(id);
      }
    }

    for (const court of courts) {
      const existing = current.get(court.id);
      if (existing) {
        existing.setCenter({ lat: court.lat, lng: court.lng });
        existing.setRadius(court.radius);
      } else {
        const circle = new google.maps.Circle({
          center: { lat: court.lat, lng: court.lng },
          radius: court.radius,
          fillColor: "#3b82f6",
          fillOpacity: 0.25,
          strokeColor: "#2563eb",
          strokeOpacity: 0.4,
          strokeWeight: 1,
          clickable: false,
          zIndex: 800,
          map,
        });
        current.set(court.id, circle);
      }
    }
  }, [map, courts]);

  useEffect(() => {
    return () => {
      for (const circle of circlesRef.current.values()) {
        circle.setMap(null);
      }
      circlesRef.current.clear();
    };
  }, []);

  return null;
}
